import {Component, EventEmitter, input, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormComponent} from '../../core/base/form.component';
import {Beneficiary} from '../../services/beneficiary/beneficiary.model';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Address} from '../../core/services/addresses/address.model';
import {Organization} from '../../core/services/user/organization.model';
import {companyIdentificationValidator} from '../../core/utils/company-identification-validator.util';
import {RELANCE_ROLE_TRANSLATIONS, RELANCE_ROLES} from '../../models/relance-role.model';
import {NormalizedAddressComponent} from '../../core/components/normalized-address/normalized-address.component';

@Component({
	selector: 'tvsub-beneficiary-form',
	templateUrl: './beneficiary-form.component.html',
	styleUrls: ['./beneficiary-form.component.scss'],
	standalone: false
})
export class BeneficiaryFormComponent extends FormComponent implements OnInit {
	@Input()
	beneficiary: Beneficiary;
	@Input()
	index: number;
	@Output()
	remove: EventEmitter<void> = new EventEmitter();
	@ViewChild(NormalizedAddressComponent)
	normalizedAddressComponent: NormalizedAddressComponent;

	roles = input<string[]>(RELANCE_ROLES);

	RELANCE_ROLE_TRANSLATIONS = RELANCE_ROLE_TRANSLATIONS;

	constructor(private fb: UntypedFormBuilder) {
		super();
	}

	ngOnInit() {
		this.form = this.fb.group({
			id: [this.beneficiary.id],
			beneficiary: this.fb.group({
				address: this.createAddressGroup(this.beneficiary.beneficiary.address),
				organization: this.createOrganizationGroup(this.beneficiary.beneficiary.organization),
				website: [this.beneficiary.beneficiary.website],
			}),
			roleDescription: [this.beneficiary.roleDescription, Validators.required],
			roleType: [this.beneficiary.roleType || '', Validators.required],
		});
	}

	getData(): any {
		return this.form.value;
	}

	isFormValid(valid: boolean = true, dontTriggerInvalidForm: boolean = false): boolean {
		let v = true;

		if (this.normalizedAddressComponent) {
			v = this.normalizedAddressComponent.isValid();
		}

		return super.isFormValid(valid && v, dontTriggerInvalidForm);
	}

	removeBeneficiary() {
		this.remove.emit();
	}

	protected onInvalidForm() {}

	protected resetInvalidForm() {}

	private createAddressGroup(address?: Address): UntypedFormGroup {
		return this.fb.group({
			id: [address?.id],
			box: [address?.box],
			cityName: [address?.cityName, Validators.required],
			name: [address?.name],
			number: [address?.number, Validators.required],
			postalCode: [address?.postalCode, Validators.required],
			province: [address?.province],
			street: [address?.street, Validators.required],
		});
	}

	private createOrganizationGroup(organization?: Organization) {
		return this.fb.group({
			companyIdentification: [organization?.companyIdentification, [Validators.required, companyIdentificationValidator]],
			name: [organization?.name, Validators.required],
		});
	}
}
